import Redirector from './Redirector';

export default Redirector;



// WEBPACK FOOTER //
// ./src/components/Redirector/index.js